<p-dialog
    visible="true"
    [maximizable]="false"
    [modal]="true"
    appendTo="body"
    [closable]="false"
    [style]="{ 'min-width': '25em' }"
    header="Update Multiple Authorizations"
>

    <form [formGroup]="updateFormGroup" #updateForm="ngForm" id="bulkUpdate" class="mt-2">
        <button
            pButton
            pRipple
            text
            class="mb-3 w-full"
            type="button"
            aria-label="Clear Bulk Updates"
            #clearBulkUpdates
            (click)="clearForm()"
            label="Clear"
        ></button>
        <p-floatLabel variant="on" class="mb-3">
            <p-select
                *ngIf="userAuthTypes as items"
                [options]="items"
                formControlName="authType"
                [filter]="true"
                styleClass="w-full"
            ></p-select>
            <label>Auth Type</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-3">
            <p-calendar
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="
                    moment().add(-5, 'year').format('YYYY') +
                    ':' +
                    moment().add(5, 'year').format('YYYY')
                "
                formControlName="startDate"
                dataType="string"
                appendTo="body"
                styleClass="w-full"
            ></p-calendar>
            <label for="float-dd">Start Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-3">
            <p-calendar
                styleClass="w-full"
                formControlName="endDate"
                dataType="string"
                appendTo="body"
                [monthNavigator]="true"
                [yearNavigator]="true"
                [yearRange]="
                    moment().add(-5, 'year').format('YYYY') +
                    ':' +
                    moment().add(5, 'year').format('YYYY')
                "
            ></p-calendar>
            <label for="float-dd">End Date</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-3">
            <p-select
                *ngIf="uniquePayrollItems as items"
                [options]="items"
                formControlName="payrollItem"
                [filter]="true"
                styleClass="w-full"
            ></p-select>
            <label for="float-dd">Payroll Item</label>
        </p-floatLabel>
        <p-floatLabel variant="on" class="mb-3">
            <p-select
                *ngIf="serviceItems as items"
                [options]="items"
                formControlName="serviceItem"
                [filter]="true"
                appendTo="body"
                styleClass="w-full"
            ></p-select>
            <label for="float-dd">Service Item</label>
        </p-floatLabel>
        <div class="flex items-center">
            <p-checkbox
                [formControl]="updateFormGroup.controls['ShowSI']"
                [binary]="true"
                data-toggle="tooltip"
                data-placement="top"
                title="✓=YES, X=NO, Blank=NO CHANGE"
                [indeterminate]="updateFormGroup.get('ShowSI')?.value === null"
            ></p-checkbox>
            <label class="ml-2">Show SI on TimeCard</label>
        </div>
        <div class="flex items-center">
            <p-checkbox
                [formControl]="updateFormGroup.controls['ShowPI']"
                data-toggle="tooltip"
                data-placement="top"
                [binary]="true"
                title="✓=YES, X=NO, Blank=NO CHANGE"
                [indeterminate]="updateFormGroup.get('ShowPI')?.value === null"
            ></p-checkbox>
            <label class="ml-2">Show PI on TimeCard</label>
        </div>
        <div class="flex items-center">
            <p-checkbox
                binary="true"
                [formControl]="updateFormGroup.controls['PremiumPayIndicator']"
                data-placement="top"
            ></p-checkbox>
            <label class="ml-2">Premium Pay</label>
        </div>
        <p-floatLabel variant="on" class="mb-3">
            <input
                pInputText
                type="text"
                class="w-full"
                aria-label="Planned Hours"
                formControlName="maxHours"
            />
            <label for="float-dd">Planned Hours</label>
        </p-floatLabel>
        <p-floatLabel variant="on" *ngIf="authClasses as items">
            <p-select
                [options]="items"
                formControlName="authClass"
                [filter]="true"
                appendTo="body"
                styleClass="w-full"
            ></p-select>
            <label for="float-dd">Class</label>
        </p-floatLabel>
    </form>
    <ng-template #footer>
        <button
            #applyBulk
            pButton
            pRipple
            text
            type="button"
            severity="success"
            aria-label="Apply Bulk Updates"
            label="Submit"
            (click)="dialogRef.close(updateFormGroup.value)"
        ></button>
        <button
            pButton
            pRipple
            text
            severity="danger"
            type="button"
            aria-label="Cancel"
            label="Cancel"
            (click)="this.dialogRef.close()"
        ></button>
    </ng-template>
</p-dialog>
